<button
  mat-raised-button
  color="primary"
  [ngClass]="{'full-width': hasFullWidth}"
  [disabled]="disabled"
  (click)="handleClick($event)"
>
  <ng-content></ng-content>
</button>
